var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreFiltres", {
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _c("BarreActions", {
        attrs: { actions: _vm.actions },
        on: {
          "appliquer-action": function($event) {
            return _vm.executerAction($event)
          }
        }
      }),
      _c("div", { staticClass: "card table-scroll height-responsive-100" }, [
        _c(
          "table",
          {
            staticClass:
              "table table-bordered table-sm text-center table-header"
          },
          [
            _c("colgroup", [
              _c("col", { attrs: { width: "100" } }),
              _c("col"),
              _vm.detaillerLots
                ? _c("col", { attrs: { width: "100" } })
                : _vm._e(),
              _vm.detaillerLots
                ? _c("col", { attrs: { width: "100" } })
                : _vm._e(),
              _c("col", { attrs: { width: "170" } }),
              _c("col", { attrs: { width: "100" } }),
              _c("col", { attrs: { width: "100" } }),
              _c("col", { attrs: { width: "170" } }),
              _c("col", { attrs: { width: "39" } })
            ]),
            _c("thead", [
              _c("th", [_vm._v("Référence")]),
              _c("th", { staticClass: "aligner-gauche" }, [
                _vm._v("Désignation")
              ]),
              _vm.detaillerLots ? _c("th", [_vm._v("N° Lot")]) : _vm._e(),
              _vm.detaillerLots ? _c("th", [_vm._v("DLC/DDM")]) : _vm._e(),
              _c("th", [
                _vm._v(
                  "Quantité au " +
                    _vm._s(
                      _vm.debut ? _vm.formatHumanDate(_vm.debut) : "__/__/____"
                    )
                )
              ]),
              _c("th", [_vm._v("Entrées")]),
              _c("th", [_vm._v("Sorties")]),
              _c("th", [
                _vm._v(
                  "Quantité au " +
                    _vm._s(
                      _vm.fin ? _vm.formatHumanDate(_vm.fin) : "__/__/____"
                    )
                )
              ]),
              _c("th")
            ])
          ]
        ),
        _c("div", { staticClass: "table-body" }, [
          _c(
            "table",
            { staticClass: "table table-bordered table-sm text-center" },
            [
              _c("colgroup", [
                _c("col", { attrs: { width: "100" } }),
                _c("col"),
                _vm.detaillerLots
                  ? _c("col", { attrs: { width: "100" } })
                  : _vm._e(),
                _vm.detaillerLots
                  ? _c("col", { attrs: { width: "100" } })
                  : _vm._e(),
                _c("col", { attrs: { width: "170" } }),
                _c("col", { attrs: { width: "100" } }),
                _c("col", { attrs: { width: "100" } }),
                _c("col", { attrs: { width: "170" } }),
                _c("col", { attrs: { width: "34" } })
              ]),
              _c(
                "tbody",
                _vm._l(_vm.lots, function(ligne, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      ligne.lot
                        ? _c("span", [_vm._v(_vm._s(ligne.lot.reference))])
                        : _vm._e()
                    ]),
                    _c("td", { staticClass: "aligner-gauche" }, [
                      ligne.lot
                        ? _c("span", [
                            _vm._v(_vm._s(ligne.lot.designationFournisseur))
                          ])
                        : _vm._e()
                    ]),
                    _vm.detaillerLots
                      ? _c("td", [
                          ligne.lot
                            ? _c("span", [_vm._v(_vm._s(ligne.lot.NumLot))])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm.detaillerLots
                      ? _c("td", [
                          ligne.lot
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatHumanDate(ligne.lot.dlcDluo))
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("afficherArrondi")(ligne.quantiteInitiale)
                          ) +
                          " " +
                          _vm._s(ligne.lot.uc) +
                          " "
                      )
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("afficherArrondi")(ligne.quantiteEntree)
                          ) +
                          " " +
                          _vm._s(ligne.lot.uc) +
                          " "
                      )
                    ]),
                    _c("td", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("afficherArrondi")(ligne.quantiteSortie)
                          ) +
                          " " +
                          _vm._s(ligne.lot.uc) +
                          " "
                      )
                    ]),
                    _c(
                      "td",
                      {
                        class: [
                          {
                            "bg-warning": _vm.anomalieStock(
                              ligne.quantiteInitiale,
                              ligne.quantiteEntree,
                              ligne.quantiteSortie,
                              ligne.quantiteFinale
                            )
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("afficherArrondi")(ligne.quantiteFinale)
                            ) +
                            " " +
                            _vm._s(ligne.lot.uc) +
                            " "
                        )
                      ]
                    ),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" }
                        },
                        [
                          _c("BtnAffichageMvtsStock", {
                            attrs: {
                              id: ligne.lot.id,
                              lot: ligne.lot,
                              debut: _vm.debut,
                              fin: _vm.fin,
                              quantiteInitiale: ligne.quantiteInitiale,
                              avecDetails: _vm.detaillerLots
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }